import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const LoginSessions = () => {
  const [userData, setUserData] = useState({ email: '', user_name: '' });
  const [emailNotificationStatus, setEmailNotificationStatus] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [activeSession, setActiveSession] = useState(null); // State to hold the active session
  const [otherSessions, setOtherSessions] = useState([]); // State to hold other sessions
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    // Fetch current user details
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        const userDetails = response.data.data.user_details;
        setUserData(user);
        setEmailNotificationStatus(userDetails.email_notification_status === 'active');
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    // Fetch login sessions
    const fetchLoginSessions = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-login-sessions`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // Set active and other sessions
        setActiveSession(response.data.active_session);
        setOtherSessions(Object.values(response.data.other_sessions)); // Convert object to array
      } catch (error) {
        console.error('Error fetching login sessions', error);
      }
    };

    fetchUserDetails();
    fetchLoginSessions();
  }, [navigate]);


  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };


  const handleCloseAllSessions = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(`${config.baseURL}/delete-login-sessions`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSuccessMessage(response.data.message);
      setErrorMessage('');
      // Reload the page after successfully closing sessions
      window.location.reload();
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error closing sessions');
      setSuccessMessage('');
      console.error('Error closing sessions', error);
    }
  };

  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${userData.user_name}`}>@{userData.user_name}</a></h3>
                    <ul>
                      <li><Link to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                       <li><Link to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link className="active_profile_menu" to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
              <div className="page_title_with_dropdown notification_page login_sessions_header">
                
                <div className="page_heading">
                  <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  <h1>Login Sessions</h1>
                </div>
                {otherSessions.length > 0 && (
                  <div className="session_btn">
                    <button className="subscription_btn subscribed" onClick={handleCloseAllSessions}>Close All Sessions</button>
                  </div>
                )}
              </div>
              <div className="edit_username_field with_top_fixed_heading privacysafetysettings">
                <div className="fields_menu_bottom_box_security">
                  <div className="edit_settings_menu_list_without_link">
                    <div className="login_sessions_block">

                      {/* Active login session */}
                      {activeSession && (
                        <div className="activeloginsessions">
                          <div className="activeloginsessions_left">
                            <strong>{activeSession.user_agent}</strong>
                            <span>{activeSession.ip_address}</span>
                          </div>
                          <div className="activeloginsessions_right">
                            <span className="active_text">Active Now</span>
                          </div>
                        </div>
                      )}

                      {/* Other login sessions */}
                      {otherSessions.length > 0 ? (
                        otherSessions.map((session, index) => (
                          <div key={index} className="otherloginsessions"> 
                            <div className="otherloginsessions_left">
                              <strong>{session.user_agent}</strong>
                              <span>{session.ip_address}</span>
                            </div>
                            <div className="otherloginsessions_right">
                              <span className="date_text">{new Date(session.created_at).toLocaleString()}</span>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="no_list">No other login sessions found</p>
                      )}

                    </div>
                  </div>
                </div>
              </div>
              <div className="message_status">
                {successMessage && <div className="alert alert-success">{successMessage}</div>}
                {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginSessions;
